function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14 0H5v9h9V0zM7 2h5v5H7V2zM9 10v9H0v-9h9zm-2 2H2v5h5v-5zM19 10v9h-9v-9h9zm-2 2h-5v5h5v-5z"
});

function SvgCompute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOSAxOSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0IDBINVY5SDE0VjBaTTcgMkgxMlY3SDdWMloiIC8+CjxwYXRoIGQ9Ik05IDEwVjE5SDBWMTBIOVpNNyAxMkgyVjE3SDdWMTJaIiAvPgo8cGF0aCBkPSJNMTkgMTBWMTlIMTBWMTBIMTlaTTE3IDEySDEyVjE3SDE3VjEyWiIgLz4KPC9zdmc+Cg==";
export { SvgCompute as ReactComponent };